import React, { useEffect, useState } from 'react';
import { listCompanies } from '../../features/masters/company/api/companyApi';
import { listBranches } from '../../features/masters/branch/api/branchApi';
import { listDepartments } from '../../features/masters/department/api/departmentApi';

const STATIC_COMPANIES = [
  { id: 1, name: 'Tez Educational School' },
  { id: 2, name: 'Tez Educational Trust' },
  { id: 3, name: 'Tez Educational Hub' },
  { id: 4, name: 'Saraswati Coaching Classes' },
  { id: 5, name: 'Tolani College Of Commerce' }
];

const STATIC_BRANCHES = [
  { id: 1, name: 'Dadar' },
  { id: 2, name: 'Thane' },
  { id: 3, name: 'Virar' },
  { id: 4, name: 'Kalyan' },
  { id: 5, name: 'Bhandup' },
  { id: 6, name: 'Charkop' },
  { id: 7, name: 'Borivali' },
  { id: 8, name: 'Mumbai' },
  { id: 9, name: 'Kurla' }
];

const STATIC_DEPARTMENTS = [
  { id: 1, name: 'TEACHER' },
  { id: 2, name: 'COUNSELLOR' },
  { id: 3, name: 'HR' },
  { id: 4, name: 'Development' },
  { id: 5, name: 'Admin' },
  { id: 6, name: 'MUM-STB-ENG' },
  { id: 7, name: 'School' },
  { id: 8, name: 'Commerce' },
  { id: 9, name: 'Science' },
  { id: 10, name: 'SUPPORT' }
];

export default function OrgStructureCheckboxPanel({
  selectedCompanies = [],
  selectedBranches = [],
  selectedDepartments = [],
  onCompaniesChange,
  onBranchesChange,
  onDepartmentsChange
}) {
  const [companies, setCompanies] = useState(STATIC_COMPANIES);
  const [branches, setBranches] = useState(STATIC_BRANCHES);
  const [departments, setDepartments] = useState(STATIC_DEPARTMENTS);

  useEffect(() => {
    async function fetchData() {
      try {
        const compData = await listCompanies();
        if (compData && compData.length > 0) {
          setCompanies(compData);
        }
      } catch (e) {
        console.warn('Using fallback companies seed data');
      }

      try {
        const branchData = await listBranches();
        if (branchData && branchData.length > 0) {
          setBranches(branchData);
        }
      } catch (e) {
        console.warn('Using fallback branches seed data');
      }

      try {
        const deptData = await listDepartments();
        if (deptData && deptData.length > 0) {
          setDepartments(deptData);
        }
      } catch (e) {
        console.warn('Using fallback departments seed data');
      }
    }
    fetchData();
  }, []);

  const handleToggle = (list, selectedList, setterFn, itemId) => {
    let updated;
    if (selectedList.includes(itemId)) {
      updated = selectedList.filter(id => id !== itemId);
    } else {
      updated = [...selectedList, itemId];
    }
    if (setterFn) {
      setterFn(updated);
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 select-none">
      
      {/* Company Panel */}
      <div className="rounded-2xl border border-outline-variant/30 bg-surface-container-lowest overflow-hidden shadow-xs flex flex-col">
        <div className="bg-surface-container-low px-4 py-2.5 border-b border-outline-variant/20 text-xs font-black uppercase tracking-wider text-on-surface-variant">
          Company
        </div>
        <div className="h-48 overflow-y-auto p-3.5 flex flex-col gap-2.5 app-hide-scrollbar">
          {companies.map((item) => {
            const isChecked = selectedCompanies.includes(item.id);
            return (
              <label key={item.id} className="flex items-center gap-3 cursor-pointer">
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={() => handleToggle(companies, selectedCompanies, onCompaniesChange, item.id)}
                  className="rounded border-outline-variant/50 text-primary focus:ring-primary/20 h-4.5 w-4.5 cursor-pointer"
                />
                <span className="text-xs font-semibold text-on-surface">{item.name}</span>
              </label>
            );
          })}
        </div>
      </div>

      {/* Branch Panel */}
      <div className="rounded-2xl border border-outline-variant/30 bg-surface-container-lowest overflow-hidden shadow-xs flex flex-col">
        <div className="bg-surface-container-low px-4 py-2.5 border-b border-outline-variant/20 text-xs font-black uppercase tracking-wider text-on-surface-variant">
          Branch
        </div>
        <div className="h-48 overflow-y-auto p-3.5 flex flex-col gap-2.5 app-hide-scrollbar">
          {branches.map((item) => {
            const isChecked = selectedBranches.includes(item.id);
            return (
              <label key={item.id} className="flex items-center gap-3 cursor-pointer">
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={() => handleToggle(branches, selectedBranches, onBranchesChange, item.id)}
                  className="rounded border-outline-variant/50 text-primary focus:ring-primary/20 h-4.5 w-4.5 cursor-pointer"
                />
                <span className="text-xs font-semibold text-on-surface">{item.name}</span>
              </label>
            );
          })}
        </div>
      </div>

      {/* Department Panel */}
      <div className="rounded-2xl border border-outline-variant/30 bg-surface-container-lowest overflow-hidden shadow-xs flex flex-col">
        <div className="bg-surface-container-low px-4 py-2.5 border-b border-outline-variant/20 text-xs font-black uppercase tracking-wider text-on-surface-variant">
          Department
        </div>
        <div className="h-48 overflow-y-auto p-3.5 flex flex-col gap-2.5 app-hide-scrollbar">
          {departments.map((item) => {
            const isChecked = selectedDepartments.includes(item.id);
            return (
              <label key={item.id} className="flex items-center gap-3 cursor-pointer">
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={() => handleToggle(departments, selectedDepartments, onDepartmentsChange, item.id)}
                  className="rounded border-outline-variant/50 text-primary focus:ring-primary/20 h-4.5 w-4.5 cursor-pointer"
                />
                <span className="text-xs font-semibold text-on-surface">{item.name}</span>
              </label>
            );
          })}
        </div>
      </div>

    </div>
  );
}
